import { useServiceProps, errorService } from "ftl-dashboards-core";
import React, { useEffect } from "react";
import FTLErrorPage from "../components/FTLErrorPage";
import { useLocation } from "react-router-dom";
export const ErrorContainer = ({ service = errorService, children, }) => {
    const [props] = useServiceProps(service);
    const location = useLocation();
    useEffect(() => {
        service.hideError();
    }, [location.pathname]);
    return React.createElement(FTLErrorPage, Object.assign({}, props), children);
};
//# sourceMappingURL=ErrorContainer.js.map